<div class="incourse-navigation {{theme}}-theme fixed-top">
    <div class="container-fluid h-100">
        <div class="row align-items-center h-100">
            <div class="col-auto border-right h-100">
                <div class="h-100 d-flex align-items-center">
                    <div class="svg-btn" data-toggle="collapse" data-target="#exit-course" aria-expanded="false"
                        aria-controls="exit-course">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15 18L9 12L15 6" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                </div>
                <div class="exit-course-content fixed-top collapse border-bottom" id="exit-course">
                    <div class="course-content-container">
                        <div class="container-fluid {{theme}}-theme py-4">
                            <div class="row p-4">
                                <div class="col-12 col-md-6">
                                    <div class="text-center text-md-left subtitle">
                                        Exit this course and return to dashboard?
                                    </div>
                                    <div class="text-center text-md-left text-green pt-3">
                                        <svg class="mr-3" width="18" height="13" viewBox="0 0 18 13" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path d="M17 1L6 12L1 7" stroke="#00B05E" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                        </svg>
                                        Your progress has been autosaved.
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 pt-4 pt-md-0">
                                    <div class="text-center text-md-right text-green">
                                        <div class="">
                                            <button type="button" class="btn btn-exit btn-primary"
                                                (click)="onExitCourse()">exit
                                                course</button>
                                        </div>
                                        <div class=" pt-3">
                                            <a role="button" data-toggle="collapse" href="#exit-course"
                                                data-target="#exit-course" aria-expanded="false"
                                                aria-controls="exit-course">No, I would like to
                                                continue working</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="text-uppercase py-3">{{navigationData.courseName}}</div>
            </div>
            <div class="col-auto">
                <div class="h-100 d-flex align-items-center">
                    <div class="svg-btn course-content-collapsable" data-toggle="collapse" data-target="#course-content"
                        aria-expanded="false" aria-controls="course-content">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z" />
                            <path
                                d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" />
                            <path
                                d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z" />
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="course-content fixed-top collapse border-bottom" id="course-content">
    <div class="course-content-container">
        <div class="container-fluid {{theme}}-theme py-4">
            <div class="row">
                <div class="col-12 footnote">COURSE CONTENTS</div>
            </div>
            <div class="row">
                <div class="col-12 col-lg-6 py-3"
                    *ngFor="let navDataItem of navigationData.partsNavigationData; let i=index">
                    <div class="subtitle border-top py-2"><a [routerLink]="getSectionLink(navDataItem)"
                            data-toggle="collapse" data-target="#course-content"
                            [innerHtml]="navDataItem.coursePartName"></a></div>
                    <ng-container *ngFor="let section of navDataItem.sections; let j=index">
                        <div
                            [ngClass]="{'pb-3 pl-3 d-flex align-items-center justify-content-between course-content-item':true, 'active': currentSectionId == section.id}">
                            <a [ngClass]="{'disabled': !section.enabled, 'active': currentSectionId == section.id, 'block-link':!section.enabled}"
                                data-toggle="collapse" data-target="#course-content" aria-expanded="false"
                                aria-controls="course-content" [routerLink]="getSectionLink(section)"
                                [innerHtml]="section.title"></a>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>